// src/pages/ConfidentialityPage.tsx

import { Link } from "react-router";
import { CONTACT_EMAIL } from "../constants/config";
import PageMeta from "../components/PageMeta";

export default function ConfidentialityPage() {
  return (
    <>
      <PageMeta
        title="Politique de confidentialité — Crush Emploi"
        description="Politique de confidentialité Crush Emploi : données collectées, finalités, droits RGPD et contact."
        path="/politique-de-confidentialite"
      />
    <main className="max-w-4xl mx-auto px-6 py-10 text-gray-800">
      <div className="flex items-center justify-between mb-8">
        <h1 className="text-3xl font-bold mb-8">
          Politique de Confidentialité
        </h1>
        <Link
          to="/"
          className="text-white p-2 rounded-lg bg-gray-600 hover:bg-gray-500 transition"
        >
          Retour
        </Link>
      </div>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">1. Introduction</h2>
        <p>
          La présente politique de confidentialité a pour but d’informer les
          utilisateurs du site <strong>Crush Emploi</strong> sur la
          manière dont leurs données personnelles sont collectées, utilisées,
          stockées et protégées.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">2. Données collectées</h2>
        <p>
          Nous collectons uniquement les données strictement nécessaires, telles
          que :
        </p>
        <ul className="list-disc list-inside ml-4 mt-2">
          <li>Adresse e-mail</li>
          <li>Prénom, pseudonyme ou nom d'entreprise</li>
          <li>Adresse IP (à des fins de sécurité ou d'analyse d’audience)</li>
        </ul>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">
          3. Finalité de la collecte
        </h2>
        <p>Les données collectées sont utilisées pour :</p>
        <ul className="list-disc list-inside ml-4 mt-2">
          <li>
            Prévenir les utilisateurs lorsque l'application Crush Emploi sera
            disponible sur les stores
          </li>
        </ul>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">4. Partage des données</h2>
        <p>
          Aucune donnée personnelle n’est vendue ou partagée avec des tiers,
          sauf en cas d’obligation légale ou avec le consentement explicite de
          l’utilisateur.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">5. Sécurité</h2>
        <p>
          Vos données sont stockées de manière sécurisée. Des mesures techniques
          et organisationnelles sont mises en place pour protéger vos
          informations contre l’accès non autorisé, la perte ou la divulgation.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">
          6. Conservation des données
        </h2>
        <p>
          Les données sont conservées pendant toute la durée d’utilisation de
          l’application et peuvent être supprimées sur simple demande à{" "}
          <a
            href={`mailto:${CONTACT_EMAIL}`}
            className="text-blue-600 hover:underline"
          >
            {CONTACT_EMAIL}
          </a>
          .
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">
          7. Droits des utilisateurs
        </h2>
        <p>Conformément au RGPD, vous disposez des droits suivants :</p>
        <ul className="list-disc list-inside ml-4 mt-2">
          <li>Droit d’accès à vos données personnelles</li>
          <li>Droit de rectification ou de suppression</li>
          <li>Droit d’opposition ou de limitation du traitement</li>
          <li>Droit à la portabilité des données</li>
        </ul>
        <p className="mt-2">
          Pour exercer vos droits, contactez-nous à :{" "}
          <a
            href={`mailto:${CONTACT_EMAIL}`}
            className="text-blue-600 hover:underline"
          >
            {CONTACT_EMAIL}
          </a>
          .
        </p>
      </section>

      <section>
        <h2 className="text-xl font-semibold mb-2">8. Modifications</h2>
        <p>Cette politique de confidentialité peut être mise à jour.</p>
      </section>
    </main>
    </>
  );
}
